import { environment } from '@bvl-admin/environments/environment';

export class RedirectEndpoint {
  public static created = `${environment.LOAD_BALANCER}/redirects`;
  public static updated = `${environment.LOAD_BALANCER}/redirects/{id}`;
  public static filter = `${environment.LOAD_BALANCER}/redirects/filters`;
  public static importExcel = `${environment.LOAD_BALANCER}/redirects/excel`;
}
